import * as React from "react";

import "./intelligent-mail-barcode.scss";

import {to_isAddressable} from "@Common/logic/template-options/template-options-is-addressable";
import {cs}               from "@Common/react/chain-services";
import {consumeContext}   from "@Common/react/context";
import {scopedState}      from "@Common/react/scoped-state";
import {scnv}             from "@Common/react/state-change-nested-value";
import {UseState}         from "@Common/react/use-state";
import {isDevQuan}        from "@Common/ui-components/debug/is-dev-quan";
import {SliderCheckbox}   from "@Common/ui-components/slider-checkbox/slider-checkbox";
import {cnv}              from "@Common/utils/arr-path";
import {chain}            from "@Common/utils/fs";
import {equalDeep, omit}  from "@Common/utils/objects";

import {ImbBase} from "../../../../../common/heavy/imb/imb-base";

export const IntelligentMailBarcode = ({templateOptions, item, method, enableAddressableShippingLogic2, next: rootNext}) => cs(
    consumeContext("company"),
    consumeContext("session"),
    consumeContext("apis"),
    ["allowed", ({company, session}, next) => next(
        to_isAddressable(templateOptions) &&
        (isDevQuan() || item?.orderType === "Postcard") &&
        true
    )],
    ["enabled", ({allowed}, next) => next(
        allowed &&
        ["shipping", "pickup"].includes(method) && enableAddressableShippingLogic2?.state.value
    )],
    ["selected", (_, next) => UseState({ // If user wants to use bulk mail
        getInitValue: () => chain(
            item?.selections?.imb,
            (_) => ({current: _, saved: _}),
        ),
        next,
    })],

    ["step1", (_, next) => rootNext({
        cleanItem: (item) => cnv(item, ["selections"], (_) => omit(_, ["imb"])),
        next,
    })],

    ["base", ({allowed}, next) => ImbBase({
        enabled: allowed,
        next,
    })],

    ["persistData", ({selected, base}, next) => next(selected.value.current && {
        "idMailer": base.idMailer,
        "idMailClass": selected.value.current.idMailClass ?? "1",
    })],
    ({enabled, selected, step1, base, persistData}) => step1.next(!enabled ? null : {
        // aa: console.log("selected.value.current", selected.value.current),
        ui: (
            <div className="intelligent-mail-barcode-83k" xd-qa-type="card" xd-qa-name="Use IMb">

                <div className="header">
                    <div className="text">
                        Use Intelligent Mail Barcode (IMb)?
                    </div>

                    {SliderCheckbox({
                        value: !!selected.value.current,
                        onChange: () => scnv(selected, ["current"], (_) => _ ? null : {}),
                        xdQaName: "Use Intelligent Mail Barcode Slider"
                    })}
                </div>

                {!!selected.value.current && base.render({
                    idMailClass: scopedState(selected, ["current", "idMailClass"]),
                })}

            </div>
        ),
        itemEditor: {

            prepareSave: (item) => ({
                newValue: cnv(item, ["selections", "imb"], () => persistData),
                // newValue: !selected.value.current ? (
                //     item
                // ) : (
                //     snv(item, ["selections", "imb"], persistData)
                // ),
                onSaved: () => scnv(selected, ["saved"], () => persistData),
            }),

            changed: !equalDeep(selected.value.saved, persistData),

            valid: !selected.value.current || base.valid,
            errorsHandling: {
                highlightErrors: base.highlightErrors,
            },
        },
    }),
);
